import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface PagesInitialStateType {
  data: {
    introduction: {
      profilePicture: string,
      opening: string,
      name: string,
      designation: string,
      inception: string,
      buttons: []
    },
    quotes: [
      {
        quote: string,
        author: string,
        backgroundImage: string
      }
    ],
    contact: {
      title: string,
      description: string,
      inputfields: [
        {
          name: string,
          placeholder: string,
          type: string,
          validation: string,
          pattern: string
        }
      ],
      textarea: {
          placeholder: string,
          name: string,
          rows: number,
          validation: string,
          pattern: string
      },
      button: {
          value: string
      },
      icon: string,
      iconcolor: string,
      colors: {
          main: string,
          second: string,
          icon: string
      },
      privacyOptIn: {
          checkbox: string,
          description: string
      }
    }
  }
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: PagesInitialStateType = {
  data: {
    introduction: {
      profilePicture: "",
      opening: "",
      name: "",
      designation: "",
      inception: "",
      buttons: []
    },
    quotes: [
      {
        quote: "",
        author: "",
        backgroundImage: ""
      }
    ],
    contact: {
      title: "",
      description: "",
      inputfields: [
        {
          name: "",
          placeholder: "",
          type: "",
          validation: "",
          pattern: ""
        }
      ],
      textarea: {
          placeholder: "",
          name: "",
          rows: 0,
          validation: "",
          pattern: ""
      },
      button: {
          value: ""
      },
      icon: "",
      iconcolor: "",
      colors: {
          main: "",
          second: "",
          icon: ""
      },
      privacyOptIn: {
          checkbox: "",
          description: ""
      }
    }
  },
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getPages = createAsyncThunk('PagesSlice/getPages', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/pages')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const PagesSlice = createSlice({
  name: "PagesSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPages.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getPages.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getPages.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getPages.fulfilled, getPages.rejected), (state) => {
        state.loading = false
      })
  }
})

const PagesThunks = {
  getPages,
}

export const PagesServices = {
  ...PagesThunks,
  actions: PagesSlice.actions,
}

const PagesReducer = PagesSlice.reducer
export default PagesReducer